import { render, staticRenderFns } from "./FormViewer.vue?vue&type=template&id=5130bb54&scoped=true&"
import script from "./FormViewer.vue?vue&type=script&lang=js&"
export * from "./FormViewer.vue?vue&type=script&lang=js&"
import style0 from "./FormViewer.vue?vue&type=style&index=0&id=5130bb54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130bb54",
  null
  
)

export default component.exports